import { useNavigate } from "react-router-dom";
import { Result, Button } from "antd";
import { MODULE_SCOPES } from "../constants/moduleScopes";
import { useModuleAccess } from "../hooks/useModuleAccess";

/**
 * 403 page shown when a user reaches a dashboard route they lack scope for.
 * A silent redirect hides the denial and can loop, so this shows an explicit
 * denial with a
 * CTA to the first dashboard the user can actually reach (falling back to
 * DashAI at "/", which is available to everyone).
 *
 * @param {{ moduleLabel?: string }} props
 */
const ModuleAccessDenied = ({ moduleLabel }) => {
  const navigate = useNavigate();
  const { canAccess } = useModuleAccess();

  const firstAllowed = MODULE_SCOPES.find((m) => canAccess(m.key));
  const target = firstAllowed?.route ?? "/";
  const targetLabel = firstAllowed?.label ?? "DashAI";

  return (
    <Result
      status="403"
      title="Access denied"
      subTitle={
        moduleLabel
          ? `You don't have access to ${moduleLabel}. Ask a workspace admin to grant it.`
          : "You don't have access to this module. Ask a workspace admin to grant it."
      }
      extra={
        <Button
          type="primary"
          onClick={() => navigate(target, { replace: true })}
        >
          Go to {targetLabel}
        </Button>
      }
    />
  );
};

export default ModuleAccessDenied;
